/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'
import {
  AppContainer,
  GameRules,
  History,
  GlobalStyle,
  ProvablyFair,
  Settings,
  useBlurAndAbove,
  Error,
  Notification,
  BetReply,
  Loading,
} from '@orbital/games-frontend-library'
import Game from './Game'
import { colors } from '../lib/colors'

import { getSettings, setAudio } from '../settings/useSettings'
import { TEXAS_PROPS } from './interfaces'
import DefaultRules from '../pages/gameRules/DefaultRules'
import CustomRules from '../pages/gameRules/CustomRules'
import CustomReply from '../pages/betReply/CustomReply'
import { handleBackgroundSFX } from './helpers/playBackground'
import { useCustomLoader } from './Loader'

export default function TexasHoldem({
  gameInfo,
  stateRound,
  seeds,
  history,
  newSeedRequest,
  seedRequest,
  requestBetReply,
  texasSocketMessages,
  stakesForSocket,
  isError,
  errorText,
  notification,
  notificationfadeOut,
  handleNotification,
  betReply,
}: TEXAS_PROPS) {
  const [blur, unBlur, settingsUnblur, above, handleAbove] = useBlurAndAbove()
  const audio = getSettings().audio
  const handleAudio = (a: any) => setAudio(a)
  const [roundId, setRoundId] = useState<string>('')
  const [showLoader, duration] = useCustomLoader(
    handleAbove,
    gameInfo.user_id,
    stateRound.state,
  )

  handleBackgroundSFX(audio, errorText, showLoader)

  const verifierFunc = () => {
    window.open('https://codepen.io/orbitalgaming/pen/ZEPOdpb', '_blank')
  }

  return (
    <AppContainer color={colors.primary}>
      <GlobalStyle />
      <Game
        gameInfo={gameInfo}
        stateRound={stateRound}
        blur={blur}
        handleAbove={handleAbove}
        colors={colors}
        audio={audio}
        handleNotification={handleNotification}
        texasSocketMessages={texasSocketMessages}
        stakesForSocket={stakesForSocket}
        isError={isError}
        showLoader={showLoader}
      />
      {above === 'settings' && (
        <Settings
          clickable={true}
          unBlur={settingsUnblur}
          colors={{
            ...colors,
            primaryLight: colors.primaryDark,
          }}
          handleAbove={handleAbove}
          handleAudio={handleAudio}
          audio={audio}
        />
      )}
      {above === 'Provably Fair' && (
        <ProvablyFair
          colors={colors}
          handleAbove={handleAbove}
          seeds={seeds}
          seedRequest={seedRequest}
          newSeedRequest={newSeedRequest}
          handleNotification={handleNotification}
          audio={audio}
          roundIsOn={false}
          verifierFunc={verifierFunc}
        />
      )}
      {above === 'Game Rules' && (
        <GameRules
          colors={{ ...colors, secondaryBackground: colors.tetriaryBackground }}
          handleAbove={handleAbove}
          audio={audio}
        >
          <>
            <DefaultRules gameInfo={gameInfo} />
            <CustomRules coefs={gameInfo.game_settings} />
          </>
        </GameRules>
      )}
      {above === 'History' && (
        <History
          clickable={true}
          unBlur={unBlur}
          handleAbove={handleAbove}
          history={history}
          audio={audio}
          toFix={gameInfo.precision}
          user_id={gameInfo.user_id}
          requestBetReply={requestBetReply}
          colors={{ ...colors, secondaryBackground: colors.tetriaryBackground }}
          handleNotification={handleNotification}
          setRoundId={setRoundId}
          betAmount={true}
        />
      )}
      {above === 'Bet Reply' && (
        <BetReply
          betReplyResponse={betReply}
          handleNotification={handleNotification}
          roundId={roundId}
          audio={audio}
          colors={{
            ...colors,
            closeStrokeColor: colors.primary,
            tertiaryDark: colors.primary,
          }}
          handleAbove={handleAbove}
          toFix={gameInfo.precision}
          betInfo={true}
          size={'18px'}
          headerpadding={'0 30px'}
        >
          <CustomReply
            betReplyResponse={betReply}
            precision={gameInfo.precision}
          />
        </BetReply>
      )}
      {showLoader && <Loading duration={duration} />}

      {notification && (
        <Notification
          colors={{ ...colors, tertiary: colors.primary }}
          fadeOut={notificationfadeOut}
          handleNotification={handleNotification}
          text={notification}
          unBlur={unBlur}
          audio={audio}
        />
      )}
      {!!errorText && <Error text={errorText} unBlur={false} audio={audio} />}
    </AppContainer>
  )
}
